// extracted by mini-css-extract-plugin
export var badge = "_vz-4";
export var selected = "_vz-1";
export var selectedOverlay = "_vz-5";
export var thumbnailButton = "_vz-0";
export var thumbnailFallback = "_vz-3";
export var thumbnailImage = "_vz-2";